export function isActive(menuUrl: string, pathname: string): boolean {
  if (!menuUrl || !pathname) return false
  // Rimuove eventuali trailing slash
  const cleanMenuUrl = menuUrl.replace(/\/$/, '')
  const cleanPath = pathname.replace(/\/$/, '')
  // Match esatto o path che inizia con menuUrl (ma non /)
  if (cleanMenuUrl === '' || cleanMenuUrl === '/') return cleanPath === '' || cleanPath === '/'
  return cleanPath === cleanMenuUrl || cleanPath.startsWith(cleanMenuUrl + '/')
}

export const stripSlash = (url: string) => url.replace(/^\/|\/$/g, '')

export const isExternalLink = (url: string) => {
  if (typeof window !== 'undefined') {
    const tmp = document.createElement('a')
    tmp.href = url
    const external = tmp.host !== window.location.host
    const whitelist: string[] = []
    const isWhitelisted = whitelist.some((domain) => tmp.host.endsWith(domain))
    const isPdfOrJpg =
      tmp.pathname.toLowerCase().endsWith('.pdf') || tmp.pathname.toLowerCase().endsWith('.jpg')
    return (external && !isWhitelisted) || isPdfOrJpg
  }
}
